import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs';
import { Permission } from 'src/app/common/enums';
import { AuthService } from 'src/app/core/authentication/auth.service';

export enum OrdersType {
  OrdersList = 1,
  OrdersStartRealizationList = 2,
  OrdersRealizationList = 3,
}

@Component({
  selector: 'app-orders-tabs-container',
  templateUrl: './orders-tabs-container.component.html',
  styleUrls: ['./orders-tabs-container.component.scss'],
  standalone: false
})
export class OrdersTabsContainerComponent implements OnInit {
  private router = inject(Router);
  private translateService = inject(TranslateService);
  private authService = inject(AuthService);

  @ViewChild(MatTabGroup, { static: true }) tabGroup: MatTabGroup;
  navigation = [
    {
      listType: OrdersType.OrdersList,
      link: 'orders/list',
      permissions: [Permission.ManageEmployeesOrder],
      labelName: this.translateService.instant('Order.List.Registry'),
    },
    {
      listType: OrdersType.OrdersStartRealizationList,
      link: 'orders/start-realization-list',
      permissions: [Permission.ManageOrderStartRealization],
      labelName: this.translateService.instant('Order.StartRealizationList.Registry'),
    },
    {
      listType: OrdersType.OrdersRealizationList,
      link: 'orders/realization-list',
      permissions: [Permission.ManageOrderRealization],
      labelName: this.translateService.instant('Order.RealizationList.Registry'),
    },
  ];

  constructor() { }

  ngOnInit(): void {
    this.setSelectedTabFromUrl(this.router.url);

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.setSelectedTabFromUrl(event.url);
    });
  }

  get filteredNavigation() {
    return this.navigation.filter((link) => this.isPermittedToTab(link.permissions));
  }

  private isPermittedToTab(permissions: Permission[]) {
    return permissions.some((p) => this.authService.hasPermission(p));
  }

  private setSelectedTabFromUrl(url: string): void {
    let selectedIndex = 0;

    for (let i = 0; i < this.navigation.length; i++) {
      const navItem = this.navigation[i];

      if (url.endsWith(navItem.link)) {
        selectedIndex = i;
        break;
      }
    }

    if (this.tabGroup) {
      this.tabGroup.selectedIndex = selectedIndex;
    }
  }

  onTabChanged(event: MatTabChangeEvent): void {
    const selectedTab = this.navigation[event.index];
    if (selectedTab) {
      this.router.navigateByUrl(selectedTab.link);
    }
  }
}
